import Vue from 'vue'
// import VueFilter from 'vue-filter'
import moment from 'moment'
import formatUtils from '@/utils/format'

// Vue.use(VueFilter)

Vue.filter('uppercase', function(value, mask) {
  if (value) {
    return value.toUpperCase()
  } else {
    return '---'
  }
})

Vue.filter('capitalize', function(value, mask) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('firstName', function(value, mask) {
  if (!value) return ''
  let names = value.toString().split(' ')
  if (!names.length) return ''
  return names[0]
})

Vue.filter('formatDateDay', function(value, mask) {
  if (value) {
    if (mask) {
      return moment(String(value), mask).format('DD/MM/YY')
    } else {
      return moment(value).format('DD')
    }
  } else {
    return '---'
  }
})

Vue.filter('formatDateMonth', function(value, mask) {
  const lang = window.$i18n && window.$i18n.locale
  if (value) {
    if (mask) {
      return moment(String(value), mask).locale(lang).format('DD/MM/YY')
    } else {
      return moment(value).locale(lang).format('MMM')
    }
  } else {
    return '---'
  }
})

Vue.filter('formatDateYear', function(value, mask) {
  if (value) {
    if (mask) {
      return moment(String(value), mask).format('DD/MM/YY')
    } else {
      return moment(value).format('YYYY')
    }
  } else {
    return '---'
  }
})

Vue.filter('formatDate', function(value, mask) {
  if (value) {
    if (mask) {
      return moment(String(value), mask).format('DD/MM/YY')
    } else {
      return moment(value).format('DD/MM/YY')
    }
  } else {
    return '---'
  }
})

Vue.filter('formatDateTimeAgo', function(value, mask) {
  if (value) {
    if (mask) {
      return moment(String(value), mask).fromNow()
    } else {
      return moment(value).fromNow()
    }
  } else {
    return '---'
  }
})

Vue.filter('formatDateExtend', function(value, mask) {
  if (value) {
    if (mask) {
      return moment(String(value), mask).format('DD/MM/YYYY')
    } else {
      return moment(value).format('DD/MM/YYYY')
    }
  } else {
    return '---'
  }
})

Vue.filter('formatDateShort', function(value, mask) {
  if (value) {
    if (mask) {
      return moment(String(value), mask).format('DD/MM')
    } else {
      return moment(value).format('DD/MM')
    }
  } else {
    return '---'
  }
})

Vue.filter('formatDateTime', function(value, mask) {
  if (value) {
    if (mask) {
      return moment(String(value), mask).format('DD/MM/YY HH:mm')
    } else {
      return moment(value).format('DD/MM/YY HH:mm')
    }
  } else {
    return '---'
  }
})

Vue.filter('phone', function(value) {
  if (value) {
    return value.replace(/[^0-9]/g, '').replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
  } else {
    return '---'
  }
})

Vue.filter('risk', function(value) {
  if (value) {
    return value.replace('in', 'em')
  } else {
    return '---'
  }
})

Vue.filter('cpf', function(value) {
  if (value) {
    if (value.length === 11) {
      return `${value.substr(0, 3)}.${value.substr(3, 3)}.${value.substr(6, 3)}-${value.substr(9, 2)}`
    } else {
      return value
    }
  } else {
    return '---'
  }
})

Vue.filter('cpfMask', function(value) {
  if (value) {
    if (value.length === 11) {
      return `XXX.XXX.XX${value.substr(8, 1)}-${value.substr(9, 2)}`
    } else {
      return value
    }
  } else {
    return '---'
  }
})

Vue.filter('cnpj', function(value) {
  if (value) {
    if (value.length === 14) {
      return `${value.substr(0, 2)}.${value.substr(2, 3)}.${value.substr(5, 3)}/${value.substr(8, 4)}-${value.substr(12, 2)}`
    } else {
      return value
    }
  } else {
    return '---'
  }
})

Vue.filter('money', function(value) {
  if (value) {
    return formatUtils.money(value)
  } else {
    return '---'
  }
})

Vue.filter('moneyWithoutDecimals', function(value) {
  if (value) {
    return formatUtils.money(value, 0)
  } else {
    return 0
  }
})

Vue.filter('number', function(value) {
  if (value) {
    return `${value}`
  } else {
    return '-'
  }
})

Vue.filter('decimal', function(value) {
  if (isNaN(value) || value === '') {
    return value
  } else {
    const val = parseFloat(value)
    return val.toFixed(2)
  }
})

Vue.filter('dynamicFilter', function(value, name, ...args) {
  return Vue.filter(name)(value, ...args)
})
